
































	import Vue from "vue";

	export default Vue.extend({
        props: {
            orderId: {
                type: Number
            },
            items: {
                type: Array
            },
            status: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                modal: $()
            }
        },
        mounted() {
            this.modal = $('#itemsModal');
            if (this.status) {
                this.modal.modal('show');
            }
        },
        methods: {
            hide() {
                this.modal.modal('hide');
            },
            show() {
                this.modal.modal('show');
            }
        }
	})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/dialogs/ItemsModal.vue